// ============================================================================
// AVAILABILITY ENDPOINTS
// ============================================================================
// API endpoint definitions for Availability module

import { buildEndpoint } from './base.endpoints';

const BASE_PATH = '/Availability';

export const availabilityEndpoints = {
  /** POST /Availability/check — check room availability */
  check: () => buildEndpoint(`${BASE_PATH}/check`),

  /** GET /Availability/calendar — get inventory calendar */
  calendar: () => buildEndpoint(`${BASE_PATH}/calendar`),

  /** GET /Availability/occupancy-horizon — rolling free-inventory strip data */
  occupancyHorizon: () => buildEndpoint(`${BASE_PATH}/occupancy-horizon`),
};

export default availabilityEndpoints;
